.spinner {
  position: relative;
  height: 16px;
  width: 16px;
}

.spinner div {
  position: absolute;
  display: block;
  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-radius: 50%;
  border-style: solid;
  box-sizing: border-box;
  border-color: var(--neutral-800) transparent transparent transparent;
  border-width: 1px;

  margin: 0;
}

.spinner div:nth-child(1) {
  animation-delay: -0.45s;
}

.spinner div:nth-child(2) {
  animation-delay: -0.3s;
}

.spinner div:nth-child(3) {
  animation-delay: -0.15s;
}

/* xs */
.spinner.xs {
  height: 16px;
  width: 16px;
}

.spinner.xs div {
  border-width: 1px;
  height: 16px;
  width: 16px;
  margin: 0;
}

/* sm */
.spinner.sm {
  height: 24px;
  width: 24px;
}

.spinner.sm div {
  border-width: 3px;
  height: 18px;
  width: 18px;
  margin: 2px;
}

/* md */
.spinner.md {
  height: 32px;
  width: 32px;
}

.spinner.md div {
  border-width:  3px;
  height: 32px;
  width: 32px;
  margin: 2px;
}

/* lg */
.spinner.lg {
  height: 64px;
  width: 64px;
}

.spinner.lg div {
  border-width:  6px;
  height: 52px;
  width: 52px;
  margin: 6px;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
